
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'data-privacy-request-ui',
  currentProjectVersion: 'static-1.5820',
  depVersions: {
  "data-privacy-request-ui": "static-1.5820",
  "client-types": "static-1.496",
  "data-fetching-client": "static-1.9956",
  "head-dlb": "static-1.5007",
  "hs-test-utils": "static-1.8331",
  "hub-http-shared-msw-handlers": "static-1.10615",
  "hubspot-dlb": "static-2.1882",
  "HubStyleTokens": "static-2.11790",
  "I18n": "static-7.1672",
  "jasmine-runner": "static-1.6752",
  "quartz": "static-1.7456",
  "react-dlb": "static-1.88",
  "rpc-client-utils": "static-1.4968",
  "ui-components-test-utils": "static-1.5927",
  "UIComponents": "static-3.8736",
  "webpack-env": "static-1.54",
  "apollo-stack-hubspot": "static-3.94",
  "foundations-assets": "static-1.5186",
  "foundations-components": "static-1-ech-accordiontransition-jank.36",
  "foundations-components-test-utils": "static-1-ech-accordiontransition-jank.36",
  "foundations-theming": "static-1.4777",
  "hub-http": "static-1.6513",
  "quartz-config": "static-1.1234",
  "quartz-core": "static-1.6675",
  "quartz-routing": "static-1.886",
  "quick-fetch": "static-1.4130",
  "raven": "static-3.5925",
  "react": "static-7.192",
  "react-rhumb": "static-1.17022",
  "SharedI18nStrings": "static-1.183",
  "ui-addon-i18n": "static-1.11448",
  "usage-tracker": "static-1.7637",
  "usage-tracker-anonymous": "static-1.6054",
  "usage-tracker-core": "static-1.7487",
  "enviro": "static-4.455",
  "hs-promise-rejection-tracking": "static-1.5587",
  "PortalIdParser": "static-2.404",
  "raven-hubspot": "static-1.6232",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "hubspot-url-utils": "static-1.4297",
  "immutable": "static-2.83",
  "metrics-js": "static-1.9867",
  "react-redux": "static-7.75",
  "redux": "static-4.76",
  "styled-components": "static-2.95",
  "bend-plugin-trellis-migration": "static-1.3619",
  "moment": "static-3.75",
  "react-dom": "static-7.85",
  "bend-plugin-quartz": "static-1.3733",
  "quartz-webpack": "static-1.3680",
  "bend-plugin-quartz-routing": "static-1.534",
  "fast-json-stable-stringify": "static-1.4",
  "graphql": "static-1.89",
  "HeadJS": "static-2.797",
  "framer-motion": "static-1.79",
  "hs-test-utils-bend-plugin": "static-1.3442",
  "msw": "static-1.39",
  "testing-library": "static-1.158",
  "ts-schema": "static-1.4294",
  "i18n-data": "static-1.229",
  "moment-timezone": "static-5.91",
  "react-utils": "static-2.5557",
  "StyleGuideUI": "static-3.502",
  "jasmine": "static-4.4614",
  "bend-plugin-chirp-manifest": "static-1.378",
  "chirp-fetch": "static-1.2195",
  "HubStyle": "static-2.12097",
  "ui-addon-draggable": "static-3.5060",
  "cssUtils": "static-1.920",
  "hs-story-utils": "static-1.9725",
  "icons": "static-2.683",
  "react-create-root-preference": "static-1.70",
  "react-select-plus": "static-1.113",
  "react-virtualized": "static-2.107",
  "ui-images": "static-2.1249",
  "bend-plugin-foundations-components": "static-1-ech-accordiontransition-jank.36",
  "floating-ui": "static-1.63",
  "foundations-theming-specialty": "static-1.2493",
  "react-aria": "static-1.72",
  "tanstack-table": "static-1.61",
  "trellis-assets": "static-1.2641",
  "ui-fonts": "static-1.1052",
  "foundations-components-legacy": "static-1-ech-accordiontransition-jank.36",
  "bend-plugin-foundations-theming": "static-1.3260",
  "foundations-theming-base": "static-1.3762",
  "stylex": "static-1.41",
  "hs-locale-management": "static-1.294",
  "opentelemetry-fe-types": "static-1.72",
  "dispatcher": "static-1.143",
  "general-store": "static-6.20",
  "hub-http-janus": "static-1.879",
  "hubspotter-http": "static-1.4864",
  "mobile-manifest-mixins": "static-1.576",
  "module-federation": "static-1.33",
  "opentelemetry-fe": "static-1.447",
  "quartz-auth": "static-1.1131",
  "quartz-head": "static-1.1121",
  "quartz-i18n": "static-1.1131",
  "quartz-test": "static-1.1131",
  "quartz-tracking": "static-1.835",
  "trellis-components": "static-1.2660",
  "usage-tracker-container": "static-1.7627",
  "csstype": "static-1.50",
  "web-vitals": "static-1.15",
  "react-input-autosize": "static-2.17",
  "bender-build-tools": "static-1.3444",
  "react-dnd": "static-5.6",
  "react-dnd-html5-backend": "static-5.6",
  "react-flip-move": "static-1.78",
  "sassPrefix": "static-1.192",
  "stylex-utils": "static-1.140",
  "trellis-theming": "static-1.1275",
  "opentelemetry-web": "static-1.13",
  "hubspotter-http-shared-msw-handlers": "static-1.10613",
  "usage-tracker-session-replay": "static-1.5323",
  "base-ui": "static-1.22",
  "react-day-picker": "static-1.10",
  "tanstack-virtual": "static-1.38",
  "amplitude-session-replay-browser": "static-1.60"
},
  depPathPrefixes: {
  "data-privacy-request-ui": "/data-privacy-request-ui/static-1.5820",
  "client-types": "/client-types/static-1.496",
  "data-fetching-client": "/data-fetching-client/static-1.9956",
  "head-dlb": "/head-dlb/static-1.5007",
  "hs-test-utils": "/hs-test-utils/static-1.8331",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.10615",
  "hubspot-dlb": "/hubspot-dlb/static-2.1882",
  "HubStyleTokens": "/HubStyleTokens/static-2.11790",
  "I18n": "/I18n/static-7.1672",
  "jasmine-runner": "/jasmine-runner/static-1.6752",
  "quartz": "/quartz/static-1.7456",
  "react-dlb": "/react-dlb/static-1.88",
  "rpc-client-utils": "/rpc-client-utils/static-1.4968",
  "ui-components-test-utils": "/ui-components-test-utils/static-1.5927",
  "UIComponents": "/UIComponents/static-3.8736",
  "webpack-env": "/webpack-env/static-1.54",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.94",
  "foundations-assets": "/foundations-assets/static-1.5186",
  "foundations-components": "/foundations-components/static-1-ech-accordiontransition-jank.36",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1-ech-accordiontransition-jank.36",
  "foundations-theming": "/foundations-theming/static-1.4777",
  "hub-http": "/hub-http/static-1.6513",
  "quartz-config": "/quartz-config/static-1.1234",
  "quartz-core": "/quartz-core/static-1.6675",
  "quartz-routing": "/quartz-routing/static-1.886",
  "quick-fetch": "/quick-fetch/static-1.4130",
  "raven": "/raven/static-3.5925",
  "react": "/react/static-7.192",
  "react-rhumb": "/react-rhumb/static-1.17022",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.183",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.11448",
  "usage-tracker": "/usage-tracker/static-1.7637",
  "usage-tracker-anonymous": "/usage-tracker-anonymous/static-1.6054",
  "usage-tracker-core": "/usage-tracker-core/static-1.7487",
  "enviro": "/enviro/static-4.455",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5587",
  "PortalIdParser": "/PortalIdParser/static-2.404",
  "raven-hubspot": "/raven-hubspot/static-1.6232",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.4297",
  "immutable": "/immutable/static-2.83",
  "metrics-js": "/metrics-js/static-1.9867",
  "react-redux": "/react-redux/static-7.75",
  "redux": "/redux/static-4.76",
  "styled-components": "/styled-components/static-2.95",
  "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.3619",
  "moment": "/moment/static-3.75",
  "react-dom": "/react-dom/static-7.85",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.3733",
  "quartz-webpack": "/quartz-webpack/static-1.3680",
  "bend-plugin-quartz-routing": "/bend-plugin-quartz-routing/static-1.534",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "graphql": "/graphql/static-1.89",
  "HeadJS": "/HeadJS/static-2.797",
  "framer-motion": "/framer-motion/static-1.79",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.3442",
  "msw": "/msw/static-1.39",
  "testing-library": "/testing-library/static-1.158",
  "ts-schema": "/ts-schema/static-1.4294",
  "i18n-data": "/i18n-data/static-1.229",
  "moment-timezone": "/moment-timezone/static-5.91",
  "react-utils": "/react-utils/static-2.5557",
  "StyleGuideUI": "/StyleGuideUI/static-3.502",
  "jasmine": "/jasmine/static-4.4614",
  "bend-plugin-chirp-manifest": "/bend-plugin-chirp-manifest/static-1.378",
  "chirp-fetch": "/chirp-fetch/static-1.2195",
  "HubStyle": "/HubStyle/static-2.12097",
  "ui-addon-draggable": "/ui-addon-draggable/static-3.5060",
  "cssUtils": "/cssUtils/static-1.920",
  "hs-story-utils": "/hs-story-utils/static-1.9725",
  "icons": "/icons/static-2.683",
  "react-create-root-preference": "/react-create-root-preference/static-1.70",
  "react-select-plus": "/react-select-plus/static-1.113",
  "react-virtualized": "/react-virtualized/static-2.107",
  "ui-images": "/ui-images/static-2.1249",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1-ech-accordiontransition-jank.36",
  "floating-ui": "/floating-ui/static-1.63",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.2493",
  "react-aria": "/react-aria/static-1.72",
  "tanstack-table": "/tanstack-table/static-1.61",
  "trellis-assets": "/trellis-assets/static-1.2641",
  "ui-fonts": "/ui-fonts/static-1.1052",
  "foundations-components-legacy": "/foundations-components-legacy/static-1-ech-accordiontransition-jank.36",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.3260",
  "foundations-theming-base": "/foundations-theming-base/static-1.3762",
  "stylex": "/stylex/static-1.41",
  "hs-locale-management": "/hs-locale-management/static-1.294",
  "opentelemetry-fe-types": "/opentelemetry-fe-types/static-1.72",
  "dispatcher": "/dispatcher/static-1.143",
  "general-store": "/general-store/static-6.20",
  "hub-http-janus": "/hub-http-janus/static-1.879",
  "hubspotter-http": "/hubspotter-http/static-1.4864",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.576",
  "module-federation": "/module-federation/static-1.33",
  "opentelemetry-fe": "/opentelemetry-fe/static-1.447",
  "quartz-auth": "/quartz-auth/static-1.1131",
  "quartz-head": "/quartz-head/static-1.1121",
  "quartz-i18n": "/quartz-i18n/static-1.1131",
  "quartz-test": "/quartz-test/static-1.1131",
  "quartz-tracking": "/quartz-tracking/static-1.835",
  "trellis-components": "/trellis-components/static-1.2660",
  "usage-tracker-container": "/usage-tracker-container/static-1.7627",
  "csstype": "/csstype/static-1.50",
  "web-vitals": "/web-vitals/static-1.15",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "bender-build-tools": "/bender-build-tools/static-1.3444",
  "react-dnd": "/react-dnd/static-5.6",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-5.6",
  "react-flip-move": "/react-flip-move/static-1.78",
  "sassPrefix": "/sassPrefix/static-1.192",
  "stylex-utils": "/stylex-utils/static-1.140",
  "trellis-theming": "/trellis-theming/static-1.1275",
  "opentelemetry-web": "/opentelemetry-web/static-1.13",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.10613",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.5323",
  "base-ui": "/base-ui/static-1.22",
  "react-day-picker": "/react-day-picker/static-1.10",
  "tanstack-virtual": "/tanstack-virtual/static-1.38",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.60"
}
};
